import React from 'react';
import { MessageCircle } from 'lucide-react';

export default function Hero({ whatsappLink }) {
    return (
        <section
            className="relative min-h-[600px] flex items-center px-4 bg-cover bg-center bg-no-repeat overflow-hidden"
        >
            {/* Background Image Layer */}
            <div
                className="absolute inset-0 z-0 after:content-[''] after:absolute after:inset-0 after:bg-black/60"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/image_hero.png'})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'right center'
                }}
            ></div>

            <div className="max-w-7xl mx-auto w-full relative z-10">
                <div className="max-w-2xl text-left">
                    <div className="opacity-70">
                        <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight text-white">
                            Seu E-commerce Pronto para <span className="text-cyan-400">Escalar</span>
                        </h1>
                        <p className="text-xl md:text-2xl text-gray-300 mb-8">
                            Desenvolvimento ágil e personalizado para pequenas e médias empresas que querem crescer rápido
                        </p>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-4">
                        <a href={whatsappLink} target="_blank" rel="noopener noreferrer"
                            className="bg-cyan-400 text-black px-8 py-4 rounded-lg font-bold text-lg hover:bg-cyan-300 transition flex items-center justify-center gap-2">
                            <MessageCircle size={20} />
                            Quero desenvolver meu projeto
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
